import { useEffect, useState } from "react";
import { Input, Modal } from "@iq/models";
import { createInventoryAdjustment } from "../../services/inventoryService";

function InventoryDetails({ isOpen, onClose, inventoryItem, onSaved }) {
    const [adjustment, setAdjustment] = useState(0);
    const [isSaving, setIsSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const currentStock = Number(inventoryItem?.quantity ?? 0);
    const parsedAdjustment = Number(adjustment);
    const projectedStock = Number.isFinite(parsedAdjustment)
        ? currentStock + parsedAdjustment
        : currentStock;

    useEffect(() => {
        setAdjustment(0);
        setErrorMessage("");
    }, [inventoryItem]);

    async function handleSave() {
        if (!inventoryItem?.id) {
            return;
        }

        if (!Number.isFinite(parsedAdjustment) || parsedAdjustment === 0) {
            setErrorMessage("Enter a non-zero quantity change.");
            return;
        }

        setIsSaving(true);
        setErrorMessage("");

        try {
            await createInventoryAdjustment({
                variantId: inventoryItem.id,
                quantity: parsedAdjustment,
                referenceType: parsedAdjustment > 0 ? "Restock" : "Inventory deduction",
                referenceId: inventoryItem.id,
            });

            await onSaved?.();
            onClose();
        } catch (error) {
            setErrorMessage(error.message || "Failed to update inventory");
        } finally {
            setIsSaving(false);
        }
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Inventory Details">
            <div>
                <Input
                    label="Product Name"
                    value={inventoryItem?.name ?? ""}
                    readOnly
                />
                <Input
                    label="SKU"
                    value={inventoryItem?.sku ?? ""}
                    readOnly
                />
                <Input
                    label="Current Stock"
                    value={currentStock}
                    readOnly
                />
                <Input
                    label="Quantity Change (positive = restock, negative = deduction)"
                    type="number"
                    value={adjustment}
                    onChange={(e) => setAdjustment(e.target.value)}
                />
                <p style={{ marginTop: "8px", color: "#666", fontSize: "0.9rem" }}>
                    New stock after change: <strong>{projectedStock}</strong>
                </p>
                {errorMessage && <p className="error">{errorMessage}</p>}
                <button
                    type="button"
                    onClick={handleSave}
                    disabled={isSaving}
                    style={{
                        marginTop: "12px",
                        padding: "10px 16px",
                        borderRadius: "6px",
                        border: "none",
                        background: "#2d6cdf",
                        color: "#fff",
                        cursor: isSaving ? "not-allowed" : "pointer",
                    }}
                >
                    {isSaving ? "Saving..." : "Save"}
                </button>
            </div>
        </Modal>
    );
}

export default InventoryDetails;